<template>
    <v-container class="my-5">
        <!--    Diálogo Persistente para mostrar Relacion de scocios con comunicados  -->
        <v-dialog v-model="dialogListStudentsByClassroom" persistent scrollable max-width="500px">
            <v-card>
                <v-toolbar class="mb-5" dark color="primary">
                    <v-toolbar-title>
                        {{$t('send_communication_owners')}}
                    </v-toolbar-title>
                    <v-spacer/>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialogListStudentsByClassroom = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <template v-if="dataListStudents.length !== 0 && !bandAlreadyPassedList" v-slot:extension>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                        v-bind="attrs"
                                        v-on="on"
                                        fab
                                        color="blue"
                                        bottom
                                        left
                                        absolute
                                        :disabled="selected.length === 0"
                                        @click="addListGenericNoticeByUser()"
                                >
                                    <v-icon>mdi-send</v-icon>
                                </v-btn>
                            </template>
                            <span>{{$t('send_communication_selected_owners')}}</span>
                        </v-tooltip>
                    </template>
                </v-toolbar>
                <v-card-text>
                    <div v-if="dataListStudents.length !== 0">
                        <v-data-table
                                v-model="selected"
                                :headers="bandAlreadyPassedList === true ? headers3 : headers2"
                                :items="dataListStudents"
                                :single-select="singleSelect"
                                item-key="idUser"
                                :show-select="!bandAlreadyPassedList"
                                class="elevation-1"
                                hide-default-footer
                                :items-per-page="-1"
                        >
                            <template  v-if="bandAlreadyPassedList === true" v-slot:item.sent="{ item }">
                                <v-tooltip v-if="item.sent === true" bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                                v-bind="attrs"
                                                v-on="on"
                                                small
                                                dark
                                                color="primary"
                                                class="mr-2"
                                                :loading="loading"
                                                @click="deleteGenericNoticeByUser(item.idGenericNotice, item.idUser)"
                                        >
                                            <v-icon>mdi-check</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{$t('quitar')}}</span>
                                </v-tooltip>
                                <v-tooltip v-if="item.sent === false" bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                                v-bind="attrs"
                                                v-on="on"
                                                small
                                                dark
                                                color="red"
                                                class="mr-2"
                                                :loading="loading"
                                                @click="addGenericNoticeByUser(item.idGenericNotice, item.idUser)"
                                        >
                                            <v-icon>mdi-close</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{$t('agregar')}}</span>
                                </v-tooltip>
                            </template>
                        </v-data-table>
                    </div>
                    <div v-else class="text-center">
                        <h2>Aún no hay ningún socio registrado.</h2>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!--   Diálogo para Mostrar un mensaje al Eliminar Reporte     -->
        <v-dialog v-model="deleteDialog" max-width="350">
            <v-card>
                <v-card-title class="headline">
                    {{$t('msg_delete_notice')}}
                </v-card-title>

                <v-card-text>
                    {{$t('msg_accion_deshacer')}}
                </v-card-text>

                <v-card-actions>
                    <v-btn
                            color="primary"
                            @click="deleteDialog = false"
                    >
                        No
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                            :loading="loading"
                            color="primary"
                            @click="deleteGenericNotice()"
                    >
                        {{$t('Si')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="finishDialog" max-width="350">
          <v-card class="elevation-5">
            <v-toolbar dark color="primary">
              <v-toolbar-title>
                {{$t('evidence')}}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn
                  class="align-self-end"
                  color="red"
                  icon
                  @click="clear(), finishDialog = false"
              ><v-icon>mdi-close</v-icon></v-btn>
            </v-toolbar>
            <v-card-text>
              <div class="text-justify">
                {{$t('msg_evidence')}}
              </div>
              <v-checkbox
                  v-model="changeFinish"
                  name="changeFinish"
                  :label="$t('agregar') + ' '+ $t('file')"
              ></v-checkbox>
              <v-file-input
                  v-model="administrator_file"
                  :disabled="!changeFinish"
                  :rules="rules"
                  outlined
                  accept="image/png, image/jpeg"
                  placeholder="image"
                  prepend-icon="mdi-paperclip"
                  @change="oversized_function2"
                  :error-messages="errores.administrator_file"
                  :label="$t('file')"
              ></v-file-input>
              <v-textarea
                  v-model="comments_manager"
                  name="comments_manager"
                  counter
                  outlined
                  maxlength="300"
                  prepend-icon="mdi-comment-edit"
                  :label="$t('comments')"
                  :error-messages="errores.comments_manager"
              ></v-textarea>
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" @click="clear(), finishDialog = false">{{$t('cerrar')}}</v-btn>
              <v-spacer/>
              <v-btn :loading="loading" :disabled="oversized" color="primary" @click="updateStatusReport">{{$t('aceptar')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <h2 class="subheading grey--text">{{$t('Areas')}}</h2>
        <v-layout align-center justify-center fill-height>
            <v-dialog v-model="dialogView" persistent scrollable max-width="350px">
                <template v-slot:activator="{ on }">
                    <v-layout row wrap class="justify-center">
                        <v-btn
                                v-if="(getProfile.role === 1) && (getProfile.department_manager === true || getProfile.staff)"
                                color="primary"
                                v-on="on"
                                @click="change = false, update = false, cleanFields()"
                        >
                            + {{$t('add_area')}}
                        </v-btn>
                    </v-layout>
                </template>
              <v-form
                  @submit.prevent="update
                            ? updateArea(itemDetail.id)
                            : addArea()"
              >
                <v-card class="elevation-5">
                  <v-toolbar dark :color="itemDetail.color">
                    <v-toolbar-title>
                      <h3>{{itemDetail.name}}</h3>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        class="align-self-end"
                        color="black"
                        icon
                        @click="dialogView = false"
                    ><v-icon>mdi-close</v-icon></v-btn>
                  </v-toolbar>
                  <v-card-text class="align-center">
                    <v-text-field
                        class="mt-3"
                        v-model="title"
                        name="title"
                        counter
                        outlined
                        maxlength="100"
                        prepend-icon="mdi-format-title"
                        :label="'*' + $t('nombre')"
                        :error-messages="errores.name"
                    ></v-text-field>
                    {{ $t('select_color') }}
                    <v-color-picker
                        v-model="color"
                        hide-mode-switch
                        dot-size="25"
                    ></v-color-picker>
                    {{ showColor }}
                  </v-card-text>
                  <v-card-actions>
                    <v-btn color="primary" @click="clear(), dialogView = false">{{$t('cerrar')}}</v-btn>
                    <v-spacer/>
                    <v-btn v-if="update" :loading="loading" color="primary" type="submit">{{$t('modificar')}}</v-btn>
                    <v-btn v-else :loading="loading" color="primary" type="submit">{{$t('agregar')}}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-dialog>
        </v-layout>
        <v-layout row wrap class="my-4" align-center justify-center fill-height>
                <v-flex
                  v-for="report in genericNotices"
                  :key="report.id"
                  xs12 sm6 md4 lg3
                  class="ma-1"
                >
                  <v-card
                      v-if="getProfile.role === 1"
                      @click="errores = [],
                      update = true,
                      itemDetail = report,
                      title = itemDetail.name,
                      color = itemDetail.color,
                      show = false,
                      dialogView = true"
                      :color="report.color"
                  >
                    <v-card-title>{{ report.name}}</v-card-title>
                    <v-card-text>
                    </v-card-text>
                  </v-card>
                  <v-card
                      v-else
                      @click="errores = []"
                      :color="report.color"
                  >
                    <v-card-title>{{ report.name}}</v-card-title>
                    <v-card-text>
                    </v-card-text>
                  </v-card>
                </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import axios from 'axios'
import store from '@/store'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'areas',
  created () {
    this.getTypeNotices()
    this.getGenericNotices()
  },
  computed: {
    ...mapGetters(['getProfile']),
    ...mapState(['language']),
    color: {
      get () {
        return this.type
      },
      set (v) {
        this.type = v
      }
    },
    showColor () {
      return this.color
    }
  },
  data: () => ({
    dialog: false,
    finishDialog: false,
    idTypeNotice: '',
    typeReports: [],
    title: '',
    titleAux: '',
    comments: '',
    comments_manager: '',
    commentsAux: '',
    loadingDataReports: false,
    loading: false,
    genericNotices: [],
    errores: [],
    idUpdate: 0,
    idNoticeDelete: 0,
    deleteDialog: false,
    file: null,
    administrator_file: null,
    update: false,
    change: false,
    changeFinish: false,
    rules: [],
    oversized: false,
    dialogView: false,
    itemDetail: {
      id: '',
      title: '',
      creation_date: '',
      finish_date: '',
      file: '',
      comments: '',
      status: -1
    },
    show: false,
    singleSelect: false,
    headers2: [],
    headers3: [],
    bandAlreadyPassedList: false,
    dataListStudents: [],
    selected: [],
    dialogListStudentsByClassroom: false,
    type: 'hex',
    hex: '#FF00FF'
  }),
  beforeUpdate () {
    this.rules = [
      value => !value || value.size < 2000000 || this.$t('msg_overflow_file')
    ]
    this.headers2 = [
      {
        text: this.$t('Nombre'),
        align: 'left',
        sortable: false,
        value: 'fullName'
      },
      {
        text: this.$t('enviado'),
        value: 'data-table-select'
      }
    ]
    this.headers3 = [
      {
        text: this.$t('Nombre'),
        align: 'left',
        sortable: false,
        value: 'fullName'
      },
      {
        text: this.$t('enviado'),
        align: 'center',
        sortable: false,
        value: 'sent'
      }
    ]
  },
  methods: {
    newPage (url) {
      window.open(url, '_blank')
    },
    oversized_function (value) {
      console.log('Valor Archivo = ', value)
      if (value !== null) {
        if (value.size > 2048 * 1024) {
          this.oversized = true
        } else {
          this.oversized = false
        }
        console.log('ERoores = ', this.errores.file)
        if (this.change === true && this.errores.file) {
          this.errores.file = ''
        }
      } else {
        this.oversized = false
      }
    },
    oversized_function2 (value) {
      console.log('Valor Archivo = ', value)
      if (value !== null) {
        if (value.size > 2048 * 1024) {
          this.oversized = true
        } else {
          this.oversized = false
        }
        console.log('ERoores = ', this.errores.administrator_file)
        if (this.changeFinish === true && this.errores.administrator_file) {
          this.errores.administrator_file = ''
        }
      } else {
        this.oversized = false
      }
    },
    getGenericNotices () {
      this.loadingDataReports = true
      const config = {
        method: 'get',
        url: 'https://clubtest.intrare.app/area/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.genericNotices = response.data
          this.loadingDataReports = false
        })
        .catch(error => {
          this.loadingDataReports = false
          console.log(error)
        })
    },
    alreadyPassedList (list) {
      let band = false

      console.log('Passed LIST')
      console.log(list)
      this.selected = []
      for (let i = 0; i < list.length; i++) {
        if (list[i].sent === true) {
          this.selected.push(list[i])
          band = true
        }
      }
      return band
    },
    deleteGenericNoticeByUser (uuidGenericNotice, uuidUser) {
      this.loading = true
      const config = {
        method: 'delete',
        url: ' https://clubtest.intrare.app/delete_generic_notice_by_user/' + uuidGenericNotice + '/' + uuidUser,
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config).then(ok => {
        this.loading = false
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_color', 'warning')
        this.$store.commit('snackbar_change_message', this.$t('msg_notice_user_deleted'))
        this.getGenericNoticesByUser(this.itemDetail.id)
        setTimeout(this.clear, 3000)
      })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    addGenericNoticeByUser (uuidGenericNotice, uuidUser) {
      let aux = []
      aux.push({
        'idGenericNotice': uuidGenericNotice,
        'idUser': uuidUser
      })
      this.loading = true
      const config = {
        method: 'post',
        url: ' https://clubtest.intrare.app/set_generic_notice_by_user',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: aux
      }
      axios(config).then(ok => {
        this.loading = false
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_color', 'success')
        this.$store.commit('snackbar_change_message', this.$t('msg_notice_user_added'))
        this.getGenericNoticesByUser(this.itemDetail.id)
        setTimeout(this.clear, 3000)
      })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    addListGenericNoticeByUser () {
      console.log('Datos Seleccionados')
      console.log(this.selected)
      let aux = []
      for (let i = 0; i < this.selected.length; i++) {
        aux.push({
          'idGenericNotice': this.itemDetail.id,
          'idUser': this.selected[i].idUser
        })
        console.log(aux)
      }
      this.loading = true
      const config = {
        method: 'post',
        url: ' https://clubtest.intrare.app/set_generic_notice_by_user',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: aux
      }
      axios(config).then(ok => {
        this.loading = false
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_color', 'success')
        this.$store.commit('snackbar_change_message', this.$t('msg_notice_user_sent'))
        this.getGenericNoticesByUser(this.itemDetail.id)
        setTimeout(this.clear, 3000)
      })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    getGenericNoticesByUser (uuidGenericNotice) {
      this.loading = true
      const config = {
        method: 'get',
        url: 'https://clubtest.intrare.app/get_generic_notice_by_user/' + uuidGenericNotice,
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.loading = false
          this.dataListStudents = response.data
          this.bandAlreadyPassedList = this.alreadyPassedList(response.data)
          // console.log('Pasó lista?', this.bandAlreadyPassedList)
          // this.dialogListStudentsByClassroom = true
        })
        .catch(error => {
          this.loading = false
          console.log(error)
        })
    },
    getTypeNotices () {
      const config = {
        method: 'get',
        url: 'https://clubtest.intrare.app/type_notice_create_get/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.typeReports = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    addArea () {
      this.loading = true
      this.errores = []
      const config = {
        method: 'post',
        url: 'https://clubtest.intrare.app/area/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          idHousingUnit: this.getProfile.idHousingUnit,
          name: this.title,
          color: this.color
        }
      }
      axios(config)
        .then(ok => {
          this.loading = false
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('msg_area_added'))
          this.dialogView = false
          this.getGenericNotices()
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            if (error.response.data) {
              this.errores = error.response.data
            }
          }
        })
    },
    updateArea (id) {
      this.loading = true
      this.errores = []

      const config = {
        method: 'patch',
        url: 'https://clubtest.intrare.app/area/' + id,
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          name: this.title,
          color: this.color
        }
      }
      axios(config)
        .then(ok => {
          this.loading = false
          this.getGenericNotices()
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('msg_area_updated'))
          this.dialog = false
          this.dialogView = false
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            if (error.response.data) {
              this.errores = error.response.data
            }
          }
        })
    },
    updateStatusReport () {
      this.loading = true
      this.errores = []
      var bodyFormData = new FormData()

      bodyFormData.set('status', 2)
      bodyFormData.set('comments_manager', this.comments_manager)
      bodyFormData.set('finish_date', new Date().toISOString().substr(0, 10))
      if (this.changeFinish === true) {
        bodyFormData.append('administrator_file', this.administrator_file)
      }
      const config = {
        method: 'patch',
        url: 'https://clubtest.intrare.app/report_get_detail_and_update_it/' + this.idUpdate + '/',
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: bodyFormData
      }
      axios(config)
        .then(ok => {
          this.loading = false
          this.getGenericNotices()
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('msg_notice_updated'))
          this.finishDialog = false
          this.dialogView = false
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            if (error.response.data) {
              this.errores = error.response.data
            }
          }
        })
    },
    sendApprovalRequest () {
      this.loading = true

      const config = {
        method: 'patch',
        url: 'https://clubtest.intrare.app/generic_notice/send_approval_request/' + this.idUpdate,
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(ok => {
          this.loading = false
          this.getGenericNotices()
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('msg_generic_notice_send'))
          this.dialogView = false
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            if (error.response.data) {
              this.errores = error.response.data
            }
          }
        })
    },
    deleteGenericNotice () {
      this.loading = true
      const config = {
        method: 'delete',
        url: ' https://clubtest.intrare.app/generic_notice_get_detail_and_update_it/' + this.idNoticeDelete + '/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config).then(ok => {
        this.loading = false
        console.log('Report con ID = ', this.idNoticeDelete + ' eliminado Correctamente.')
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_color', 'warning')
        this.$store.commit('snackbar_change_message', this.$t('msg_notice_deleted'))
        this.getGenericNotices()
        setTimeout(this.clear, 3000)
        this.dialogView = false
        this.deleteDialog = false
      })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    cleanFields () {
      this.title = ''
      this.color = '#FF6666'
      this.comments = ''
      this.idTypeNotice = null
      this.file = null
      this.oversized = false
      this.itemDetail = {
        id: 0,
        name: this.$t('add_area'),
        color: 'primary'
      }
    },
    fillFields (item) {
      if (item.file !== null) {
        var fileAux = new File(['foo'], item.file)
        this.file = fileAux
      }
      this.title = item.title
      this.titleAux = item.title
      this.comments = item.comments
      this.commentsAux = item.comments
      this.idTypeNotice = item.idTypeNotice
      this.oversized = false
    },
    clear: function () {
      this.errores = []
      this.$store.commit('snackbar_change_color', 'success')
      // this.$validator.reset()
      this.$store.commit('snackbar_activate_false')
    },
    changeStatus () {
      console.log('changeStatus')
    },
    extensionImage (url) {
      if (url.includes('.png') || url.includes('.gif') || url.includes('.jpeg') || url.includes('.jpg')) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style scoped>

</style>
